import { FunctionComponent, useEffect, useState } from "react";

import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import validateDigits from "../../../utils/validateDigits";
import SourceAccount from "../../../class/sourceAccount";
import HeadingContainer from "../../../layout/heading-container";
import { Button, SearchableDropdown, TextField } from "@manifesthhqinc/ui-library";
import { InputFormContainer } from "../../../layout/container/InputFormContainer";
import { TitleLarge } from "../../../components/font";
import EmployerSearch from "../../../components/employer-search";

const OldAccountEmploymentDetails: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const {
    currentSourceAccountStep,
    currentOldAccountDetails,
    updateOldAccountDetails,
    fetchProvider,
    validateField,
    validation,
    providerList,
    employerAPI,
  } = props;

  const [initialRender, setInitialRender] = useState<boolean>(true);
  useEffect(() => {
    setInitialRender(false);
  }, []);

  useEffect(() => {
    if (!initialRender) {
      validateField("startYear");
    }
  }, [currentOldAccountDetails.startYear]);

  useEffect(() => {
    if (!initialRender) {
      validateField("terminatedYear");
    }
  }, [currentOldAccountDetails.terminatedYear]);

  const handleInputChange = (name: keyof SourceAccount, value: string) => {
    if (validateDigits(value)) {
      updateOldAccountDetails({ ...currentOldAccountDetails, [name]: value });
    } else {
      // ignore input if it's not a digit(0-9)
    }
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge>Got it! We’ll need a few more details to help find your old account</TitleLarge>
          </HeadingContainer>
          <InputFormContainer>
            <EmployerSearch
              value={
                currentOldAccountDetails.planSponsor
                  ? {
                      label: currentOldAccountDetails.planSponsor,
                      value: currentOldAccountDetails.planSponsorId,
                    }
                  : undefined
              }
              error={false}
              readOnly={false}
              name="search-employer-name"
              onChange={(e) =>
                updateOldAccountDetails({
                  planSponsor: e?.label,
                  planSponsorId: e?.__isNew__ ? "" : e?.value,
                })
              }
              api={employerAPI}
            />
            <TextField
              name="startYear"
              value={currentOldAccountDetails.startYear}
              readOnly
              title="Approximate start year"
              size="large"
              placeholder="YYYY"
              onChange={(e) => handleInputChange("startYear", e.target.value)}
              onBlur={() => validateField("startYear")}
              errorText={(validation?.startYear as string) || undefined}
              isError={Boolean(validation?.startYear)}
              type="text"
              inputMode="numeric"
            />
            <TextField
              name="endYear"
              value={currentOldAccountDetails.terminatedYear}
              readOnly
              title="Approximate end year"
              size="large"
              placeholder="YYYY"
              onChange={(e) => handleInputChange("terminatedYear", e.target.value)}
              onBlur={() => validateField("terminatedYear")}
              errorText={(validation?.terminatedYear as string) || undefined}
              isError={Boolean(validation?.terminatedYear)}
              type="text"
              inputMode="numeric"
            />
            <SearchableDropdown
              size="large"
              placeholder="Fidelity, TIAA, etc."
              name="oldProvider"
              title="Old provider (Optional)"
              options={providerList.map((e) => ({ label: e, value: e }))}
              value={currentOldAccountDetails.providerName}
              onChange={(e) => updateOldAccountDetails({ providerName: e?.value })}
              supportingText="If you remember who your old provider is, provide the name and Manifest will verify for you."
            />
          </InputFormContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="searchProvider" size="large" onClick={() => fetchProvider(currentOldAccountDetails)}>
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default OldAccountEmploymentDetails;
